<template>
    <div :style="{
             'padding': withCheckbox ? '1px' : '2px',
             'border-color': outer ? color : 'transparent',
             'width': `${size}px`,
             'height': `${size}px`,
             'line-height': `${size - 2}px`
         }"
         class="outer-rect"
         :class="withCheckbox ? '' : 'd-hover'">
        <div v-show="withCheckbox" :style="{ 'font-size': `${size - 4}px`, color }" class="align-middle">
            <i class="far fa-check"></i>
        </div>
        <div v-show="!withCheckbox && withInnerSquare" :style="{ 'background-color': color || 'transparent' }"></div>
    </div>
</template>

<script>
export default {
    name: 'AppStatusColoredRect',
    props: {
        color: {
            type: String,
            required: true,
            default: 'grey'
        },
        outer: {
            type: Boolean,
            default: true
        },
        withCheckbox: {
            type: Boolean,
            default: false
        },
        withInnerSquare: {
            type: Boolean,
            default: true
        },
        size: {
            type: Number,
            default: 15
        }
    }
}
</script>

<style lang="scss" scoped>
    .outer-rect {
        border-width: 1px;
        border-style: solid;

        div {
            width: 100%;
            height: 100%;
        }

        .rect-checkbox {
            font-size: 11px;
        }
    }
</style>
